"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nativeCsvReader = exports.nativeCsvReaderResultSchema = exports.nativeCsvReaderArgsSchema = exports.SourceTypeSchema = exports.CsvDataRowSchema = exports.CSVStatusEnumSchema = exports.CsvDataRowIdSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.CsvDataRowIdSchema = zod_1.z
    .string()
    .describe('required: The row id identifies the source row this row was originally read from. Normally, will be the row number, but can be a unique id based on the integration.');
exports.CSVStatusEnumSchema = zod_1.z.enum(['filtered', 'deleted']);
exports.CsvDataRowSchema = zod_1.z.union([
    zod_1.z.object({
        id: exports.CsvDataRowIdSchema,
        hs: zod_1.z
            .array(zod_1.z.string())
            .describe('Headers. array of strings, one for each header in the CSV or XLSX file.'),
        row: zod_1.z
            .array(zod_1.z.string())
            .describe('Array of strings, one for each column in the row. Must have the same number of columns as the headers.'),
    }),
    zod_1.z
        .object({
        id: exports.CsvDataRowIdSchema,
        status: exports.CSVStatusEnumSchema.describe('Status of the row. "filtered" if the row was filtered out, "deleted" if the row was deleted. This is used by CSVWriter to determine wether to delete the data from original source'),
    })
        .describe('Deleted or Filtered row. Only the id is preserved.'),
]);
var SourceTypeEnumSchema = zod_1.z.enum(['raw', 'url', 'gsheet']);
exports.SourceTypeSchema = zod_1.z.discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal(SourceTypeEnumSchema.enum.raw),
        content: zod_1.z.string(),
    })
        .describe('Plain string field accepting CSV content.'),
    zod_1.z
        .object({
        type: zod_1.z.literal(SourceTypeEnumSchema.enum.url),
        url: zod_1.z.string(),
    })
        .describe('URL field accepting CSV or XLSX content.'),
    zod_1.z
        .object({
        type: zod_1.z.literal(SourceTypeEnumSchema.enum.gsheet),
        gsheetId: zod_1.z.string(),
        sheetId: zod_1.z.string(),
    })
        .describe('Google Spreadsheet ID (page) and Sheet ID (tab) field accepting CSV content.'),
]);
// Argument schema
exports.nativeCsvReaderArgsSchema = zod_1.z.object({
    sourceType: exports.SourceTypeSchema.describe('The type of the source CSV. Determines how to pull down the data. Supports both CSV and XLSX formats.'),
    emitMode: common_1.emitModeSchema.describe(common_1.emitModeSchema.description + ' Default to "single".'),
});
exports.nativeCsvReaderResultSchema = zod_1.z.object({
    sourceType: exports.SourceTypeSchema.describe('The type of the source CSV. Determines how to pull down the data. Supports both CSV and XLSX formats.'),
    // needs to be named results, in order to support multiple rows
    results: zod_1.z
        .array(exports.CsvDataRowSchema)
        .describe('The CSV data. Array of CsvDataRow objects, one for each row in the CSV or XLSX file.'),
});
// Tool definition
exports.nativeCsvReader = (0, common_1.createEmitModeToolMetadata)({
    id: 'nativeCsvReader',
    displayName: 'CSV Reader',
    displayDescription: 'Read CSV and XLSX data from a string, URL, or Google Sheet URL',
    category: 'ai',
    color: common_1.BRAND_COLORS.AI,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.AI),
    icon: 'ai-csv',
    argsSchema: exports.nativeCsvReaderArgsSchema,
}, exports.nativeCsvReaderResultSchema);
